import { initEventHistory } from "./eventHistory/EventHistory";
import { EntryRule } from "./eventHistory/EntryRule";
import { onReady } from "@otto-ec/global-resources/dom";

onReady.subscribe(() => {
  initEventHistory();
  EntryRule.register();
});
